import styled from 'styled-components';
import LogoImage from '../images/logos/Nuorelle_siivet_logo.png';

const Logo = styled.img.attrs({
    src: LogoImage,
    alt: 'logo'
})`
    height: 100%;
`;

export { Logo };
